import { render } from "./sideMenu.vue?vue&type=template&id=509adeb3"
import script from "./sideMenu.vue?vue&type=script&lang=js"
export * from "./sideMenu.vue?vue&type=script&lang=js"

import "./sideMenu.vue?vue&type=style&index=0&id=509adeb3&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__